/* unplugin-vue-components disabled */import { render } from "./ConfirmClosingSales.vue?vue&type=template&id=77bf16ce&ts=true"
import script from "./ConfirmClosingSales.vue?vue&type=script&lang=ts"
export * from "./ConfirmClosingSales.vue?vue&type=script&lang=ts"

import "./ConfirmClosingSales.vue?vue&type=style&index=0&id=77bf16ce&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__